<!--
@component
Endnotes

See markup below.
-->

<script lang="ts">
  import type { ComponentProps } from 'svelte';
  import { EndNotes } from '@reuters-graphics/graphics-components';
  import { scaleLinear } from 'd3-scale';
  import { appState } from '$lib/stores/index.svelte';
  type Props = {
    notes: ComponentProps<typeof EndNotes>['notes'];
  };

  let { notes }: Props = $props();

  // Maps the navbar texture width (%) to window width for responsive scaling.
  const scaleBg = scaleLinear()
    .domain([330, 1400])
    .range([300, 100])
    .clamp(true);
</script>

<div
  class="endnotes fmt-8 fpt-5 fpb-1"
  style="--w: {scaleBg(appState.windowWidth)}%"
>
  <EndNotes {notes} />
</div>

<style lang="scss">
  @use '../../../styles/mixins' as mixins;

  .endnotes {
    background-image: url('$images/branding/navbar-texture.svg');
    background-size: var(--w);
    background-repeat: repeat-y;
    background-position: center;

    @include mixins.article-fluid;

    @media (max-width: mixins.$column-width-wide) {
      background-position-x: 80%;
    }

    :global(.notes) {
      margin-block-start: 0;
      padding-inline: 15px;
      max-width: mixins.$column-width-narrow;
    }
  }
</style>
